(function () {
  // ÜCRETSİZ KARGO SINIRI (Euro). Örn. 50 yaz. 0 kalırsa kargo çubuğu görünmez.
  var FREE_SHIPPING_EUR = 0;

  var T = {
    de: { left: 'Nur noch {x} bis zum kostenlosen Versand!', done: 'Kostenloser Versand erreicht!', kicker: 'Komplettiere deinen Look', title: 'Passende Produkte' },
    en: { left: 'Only {x} to achieve free shipping!', done: 'You have free shipping!', kicker: 'Complete your look', title: 'Complementary products' },
    tr: { left: 'Ücretsiz kargoya sadece {x} kaldı!', done: 'Kargo ücretsiz!', kicker: 'Kombini tamamla', title: 'Tamamlayıcı ürünler' }
  };
  var pageLang = document.documentElement.lang || 'de';
  var t = T[pageLang.slice(0, 2)] || T.de;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

  function money(cents) {
    try { return new Intl.NumberFormat(pageLang, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    var panel = document.getElementById('cart-notification');
    if (!panel) return;
    var host = panel.closest('cart-notification') || panel.parentNode;

    var overlay = document.createElement('div');
    overlay.className = 'ay-overlay';
    host.insertBefore(overlay, host.firstChild);
    overlay.addEventListener('click', function () {
      var btn = panel.querySelector('.cart-notification__close');
      if (btn) btn.click();
    });

    var ship = document.createElement('div'); ship.className = 'ay-ship';
    var recs = document.createElement('div'); recs.className = 'ay-recs';
    panel.appendChild(ship);
    panel.appendChild(recs);

    function renderShip(totalCents) {
      var limit = FREE_SHIPPING_EUR * 100;
      if (!limit) { ship.innerHTML = ''; return; }
      var rest = limit - totalCents;
      var pct = Math.max(0, Math.min(100, (totalCents / limit) * 100));
      var text = rest > 0 ? t.left.replace('{x}', money(rest)) : t.done;
      ship.innerHTML = '<p class="ay-ship__text">' + esc(text) + '</p>' +
        '<div class="ay-ship__track"><div class="ay-ship__fill" style="width:' + pct + '%"></div></div>';
    }

    function card(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      var onSale = p.compare_at_price && p.compare_at_price > p.price;
      var badge = onSale && (p.tags || []).indexOf('sale') > -1;
      var url = p.url || (root + 'products/' + p.handle);
      return '<a class="ay-card" href="' + esc(url) + '">' +
        '<div class="ay-card__img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        (badge ? '<span class="ay-card__badge">Deal</span>' : '') + '</div>' +
        '<div class="ay-card__vendor">' + esc(p.vendor) + '</div>' +
        '<div class="ay-card__name">' + esc(p.title) + '</div>' +
        '<div class="ay-card__price' + (badge ? ' ay-card__price--sale' : '') + '">' + money(p.price) +
        (onSale ? '<span class="ay-card__was">' + money(p.compare_at_price) + '</span>' : '') + '</div></a>';
    }

    function loadRecs(productId, intent) {
      return fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=4&intent=' + intent)
        .then(function (r) { return r.json(); })
        .then(function (d) { return (d && d.products) || []; });
    }

    function renderRecs(productId) {
      if (!productId) { recs.innerHTML = ''; return; }
      loadRecs(productId, 'complementary')
        .then(function (list) { return list.length ? list : loadRecs(productId, 'related'); })
        .then(function (list) {
          if (!list.length) { recs.innerHTML = ''; return; }
          recs.innerHTML = '<p class="ay-recs__kicker">' + esc(t.kicker) + '</p>' +
            '<h3 class="ay-recs__title">' + esc(t.title) + '</h3>' +
            '<div class="ay-recs__grid">' + list.map(card).join('') + '</div>';
        })
        .catch(function () { recs.innerHTML = ''; });
    }

    function refresh() {
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        renderShip(cart.total_price || 0);
        var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
        var id = (meta && meta.id) || (cart.items && cart.items[0] && cart.items[0].product_id);
        renderRecs(id);
      }).catch(function () {});
    }

    var wasOpen = false;
    new MutationObserver(function () {
      var open = panel.classList.contains('active');
      document.body.classList.toggle('ay-cart-open', open);
      if (open && !wasOpen) refresh();
      wasOpen = open;
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();